import { isApp } from '@bcz/fe-interface'
import { createRequest, delay } from '@/utils'
import { getUrlParam } from '@/utils/utils'
import { statGroupMap } from '@/configs/report'

const { post } = createRequest({ urlPrefix: 'https://system.baicizhan.com' })

/**
 * 事件上报
 * @param {string} eventId 事件 ID
 * @param {object} [extraInfo] 额外信息
 */
export function reportV2(eventId, extraInfo = {}, statGroup = statGroupMap.MALL) {
  const endpoint = `/api/system/report_event${isApp ? '' : '_without_login'}`
  const param = getUrlParam(location.search, { needDecode: true })
  return new Promise(resolve => {
    Promise.race([
      delay(1000),
      post(endpoint, {
        headers: { 'Content-Type': 'text/plain' },
        body: [
          {
            log_time: Date.now(),
            product_id: 'bcz_app_h5',
            stat_group: statGroup,
            event_id: eventId,
            extra_info: JSON.stringify({
              ...param,
              _path: location.pathname,
              ...extraInfo,
            }),
          },
        ],
      })
        .then(() => {
          resolve()
        })
        .catch(() => {
          resolve()
        }),
    ])
  })
}
